import { ProfileType, getProfileTypeLabel } from '../enums/ProfileType';

export class Profile {
  constructor(protected readonly id: number, protected readonly name: string, protected readonly type: ProfileType) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getType() {
    return this.type;
  }

  getTypeLabel() {
    return getProfileTypeLabel(this.type);
  }

  getLabel() {
    const label = this.getTypeLabel();
    if (label) {
      return `${this.name} (${this.getTypeLabel()})`;
    }
    return this.name;
  }
}
